<template>
  <div class="intellidata-device-iorecord">
    <!-- <div class="left content-left">
			<AreaTree v-on:handleTreeClick='handleTreeClick' :moduleName='moduleName'></AreaTree>
    </div>-->
    <div class>
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              v-model="search.plateNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="道路名称"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="设备编号"
            prop="deviceCode"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号"
            prop="plateNum"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="进场时间"
            prop="enterTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="进场图片">
            <template slot-scope="scope" >
              <el-image
                style="width: auto; height: 40px;padding:5px 0"
                :src="scope.row.enterImages.split(',')[0]"
                :preview-src-list="scope.row.enterImages.split(',')"
              >
              </el-image>
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip label="进场特写">
            <template slot-scope="scope" v-if="scope.row.enterPlateImages">
              <img
                @click="scope.row.enterPlateImages.split(',')[0]"
                :src="scope.row.enterPlateImages.split(',')[0]"
                width="50px"
                height="auto"
              />
            </template>
          </el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="出场时间"
            prop="exitTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="出场图片">
            <template slot-scope="scope" v-if="scope.row.exitImages">
               <el-image
                style="width: auto; height: 40px;padding:5px 0"
                :src="scope.row.exitImages.split(',')[0]"
                :preview-src-list="scope.row.exitImages.split(',')"
              >
              </el-image>
         
            </template>
          </el-table-column>
          <!-- <el-table-column show-overflow-tooltip label="出场特写">
            <template slot-scope="scope" v-if="scope.row.exitPlateImages">
              <img
                @click="scope.row.exitPlateImages.split(',')[0]"
                :src="scope.row.exitPlateImages.split(',')[0]"
                width="50px"
                height="auto"
              />
            </template>
          </el-table-column> -->
          <el-table-column show-overflow-tooltip label="是否补发">
            <template slot-scope="scope">
              <span>{{ scope.row.isReplenish == 1 ? "是" : "否" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--查看图片-->
    <!-- <div ref="imgDialog" class="imgDialog">
      <el-dialog
        :lock-scroll="false"
        ref="show"
        :visible.sync="photoDialogVisible"
        :show-close="false"
        width="350px"
      >
        <el-image 
    style="width: 100px; height: 100px"
    :src="url" 
    :preview-src-list="srcList">
  </el-image>
      </el-dialog>
    </div> -->

    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  requestIntellidataDeviceIORecord,
  delIORecord,
  getAllIOList,
  getIORecordList,
  dictValue,
  getAppList,
  getHandsetSingle,
  dealHandset,
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  data() {
    return {
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      treeData: {
        parkingId: "",
      },
      observer: null,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        elementHeight: "0",
      },
      observer1: null,
      innerRecordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        innerHeight: "0",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      moduleName: "",
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        plateNumber: "",
        beginDate: "",
        chargeDate: "",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},

      defaultProps: {
        children: "children",
        label: "label",
      },
      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      // if(!this.treeData.parkingId){
      // this.$message({
      // 	type:"warning",
      // 	message:'请选择车场'
      // })
      // return;
      // }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    // handleTreeClick:function(node,data){
    // 	this.search.beginDate='';
    // 	this.search.chargeDate='';
    // 	this.search.spaceNum='';
    // 	if(node.type!='parking'){
    // 		this.treeData.parkingId='';
    // 		var pageObj={
    // 				curIndex:1,
    // 				rowsCount:0
    // 			};
    // 		this.getPage(pageObj);
    // 		this.tableListData.rows=[];
    // 		// this.$message({
    // 		// 	message: '请选择车场',
    // 		// 	type: 'warning'
    // 		// });
    // 		return;
    // 	}else{
    // 		this.treeData.parkingId=node.id;
    // 		this.search.pageNumber=1;
    // 		this.tableList(this.search.pageNumber)
    // 	}
    // },
    tableList: function(curPage) {
      var _this = this;
      this.$get(requestIntellidataDeviceIORecord(), {
        limit: this.search.pageSize,
        page: curPage,
        plateNum: this.search.plateNumber,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页

        var rows = data.data.rows;

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows.map(record=>{
          if(!record?.enterImages)record.enterImages=''
          if(!record?.exitImages)record.exitImages=''
          return record
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    searchList: function() {
      // if(!this.treeData.parkingId){
      // 			this.$message({
      // 				type:"warning",
      // 				message:'请选择车场'
      // 			})
      // 			return;
      // 		}
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    previewPhoto(url) {
      this.photoDialogVisible = true;

      //   this.$refs.imgDialog.style.height = window.screen.height + "px";
      //   this.$refs.imgDialog.style.width = window.screen.width + "px";
      //   this.$refs.imgDialog.style.background = "rgba(0,0,0,0.5)";
      //  this.$refs.imgDialog.style.opacity=0.5
      this.$refs.imgDialog.style.position = "fixed";
      this.$refs.imgDialog.style.top = 0 + "px";
      this.$refs.imgDialog.style.left = 0 + "px";

      if (!url) {
        this.photoY = false;
        this.photoN = true;
      } else {
        this.photoY = true;
        this.photoN = false;

        this.$refs.img.src = url;

        this.imgDialog.dialogWidth = "" + this.$refs.img.width;
      }

      this.imgDialog.url = url;
      this.$refs.show.open();
    },
    hiddenShade() {
      this.$refs.imgDialog.style.height = 0 + "px";
      this.$refs.imgDialog.style.width = 0 + "px";
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,

    // Refresh
  },

  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
/* .left{
		width:20%;
		float:left;
		/*border-right:1px solid #278cd8;*/
/*margin-right:0.5%*/
/* }
	.right{
		width:80%;
		float:right;
		position:relative;
		height:660px;
	}  */
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.intellidata-device-iorecord img {
  display: inline-block;
  margin-right: 2px;
}
</style>
<style>
.el-image{
  vertical-align: middle;
}
</style>
